export default __webpack_public_path__ + "static/slide-2-241c03c3c72a7a4211e3ce038f648511.png";